<!-- Sign In Form -->
<pmd-alert type="success"
    *ngIf="successMessage"
    class="mb-4">
    {{ successMessage }}
</pmd-alert>
<form aria-label="Sign in to Your Account"
    *ngIf="isLoginFormVisible"
    class="login-section pmd-form-card"
    [formGroup]="loginForm"
    autocomplete="off"
    (ngSubmit)="login()">

    <h2 class="card-title mb-4">Sign in to access your account</h2>
    <pmd-alert type="danger"
        *ngIf="errorMessage">
        {{ errorMessage }}
    </pmd-alert>
    <div [ngClass]="sharedService.pmdStatusClass(f.username, isSubmitAttempted)">
        <label for="loginemail"
            class="col-form-label">Mobile number / Email ID <strong class="text-danger">*</strong></label>
        <pmd-textfield pmd-textfield-outline
            class="mb-2">
            <input id="loginemail"
                type="text"
                class="form-control"
                formControlName="username"
                [ngClass]="sharedService.statusClass(f.username, isSubmitAttempted)">
            <div *ngIf="sharedService.hasErrors(f.username, isSubmitAttempted)"
                class="invalid-feedback">
                <ng-container *ngIf="f.username.errors.required || f.username.errors.pattern">
                    Enter a valid mobile number / email id
                </ng-container>
            </div>
        </pmd-textfield>
    </div>
    <div [ngClass]="sharedService.pmdStatusClass(f.password, isSubmitAttempted)"
        class="mb-3">
        <div [ngClass]="sharedService.pmdStatusClass(f.password, isSubmitAttempted)">
            <label for="Password2"
                class="col-form-label">Password <strong class="text-danger">*</strong></label>
            <pmd-textfield pmd-textfield-outline
                class="mb-0 position-relative">
                <input #passwordInput
                    [type]="isPasswordVisible ? 'text' : 'password'"
                    class="form-control"
                    [ngClass]="sharedService.statusClass(f.password, isSubmitAttempted)"
                    formControlName="password"
                    aria-label="Password"
                    aria-describedby="Password">
                <i class="material-symbols-outlined md-dark visibility-icon fs-20 pf-cursor-pointer"
                    (click)="togglePasswordVisibility()">
                    {{ isPasswordVisible ? 'visibility_off' : 'visibility' }}
                </i>
            </pmd-textfield>
        </div>
        <div *ngIf="sharedService.hasErrors(f.password, isSubmitAttempted)"
            class="invalid-feedback">
            <ng-container *ngIf="f.password.errors.required || f.password.errors.minlength">
                Please enter a password
            </ng-container>
        </div>
    </div>
    <re-captcha (resolved)="onCaptchaResolved($event)"
        formControlName="recaptcha">
    </re-captcha>
    <div class="
        d-flex
        justify-content-between
        mb-3 mt-3">
        <!-- <pmd-checkbox [checked]="loginForm.value.rememberMe"
            [state]="loginForm.value.rememberMe ? 'checked' : 'unchecked'"
            formControlName="rememberMe">
            Remember Me
        </pmd-checkbox> -->
        <a [routerLink]="['/forgot-password']"
            class="text-decoration-underline">Forgot Password?</a>
        <!-- <a [routerLink]="['/demo-login']"
            class="text-decoration-underline">Demo Login</a> -->
    </div>
    <div class="">
        <button type="submit"
            pmdRipple
            pmd-btn-raised
            [disabled]="!loginForm.valid"
            [attr.aria-disabled]="!loginForm.valid"
            color="secondary">Sign In</button>
        <p class="mt-3 mb-0">
            New to Invoice? <a [routerLink]="['/sign-up']"
                class="link-text">Sign Up</a>
        </p>
    </div>
</form>
<!-- End Sign In Form -->

<!-- Forgot Password Form -->
<!-- <form *ngIf="forgotPwdForm"
    class="pmd-form-card forgotpassword-section"
    [formGroup]="forgotPwdForm"
    (ngSubmit)="forgotPwdSubmit()">

    <div class="mb-4">
        <h2 class="card-title">Forgot Password?</h2>
        <p class="card-subtitle">Please enter the email Id or mobile number associated with your account.</p>
    </div>

    <div>
        <label for="Username">Email Id or Mobile Number</label>
        <input type="text"
            class="form-control"
            >
    </div>

    <div class="">
        <button type="submit"
            pmdRipple
            (click)="sendRequestToggle()"
            pmd-btn-raised
            color="secondary">Send Request</button>
        <p class="mt-3 mb-0">Remember Password? <a href="#"
                (click)="loginToggle()"
                class="link-text">Sign In</a></p>
    </div>
</form> -->
<!-- End Forgot Password Form -->

<!-- <div id="otpFieldscreen"
    *ngIf="otpField">
    <div class="mb-4">
        <h1 class="h2 card-title">Enter 6 digit recovery code</h1>
        <p class="card-subtitle">Please enter the recovery code sent to you on your email id:
            <strong>your*****@**in.com</strong> or on your mobile number: <strong>98******78</strong>.
        </p>
    </div>
    <div class="d-flex gap-3 justify-content-center">
        <pmd-textfield pmd-textfield-outline>
            <input id="count1"
                type="text"
                class="form-control"
                >
        </pmd-textfield>
        <pmd-textfield pmd-textfield-outline>
            <input id="count2"
                type="text"
                class="form-control"
                >
        </pmd-textfield>
        <pmd-textfield pmd-textfield-outline>
            <input id="count3"
                type="text"
                class="form-control"
                >
        </pmd-textfield>
        <pmd-textfield pmd-textfield-outline>
            <input id="count4"
                type="text"
                class="form-control"
                >
        </pmd-textfield>
        <pmd-textfield pmd-textfield-outline>
            <input id="count5"
                type="text"
                class="form-control"
                >
        </pmd-textfield>
        <pmd-textfield pmd-textfield-outline>
            <input id="count6"
                type="text"
                class="form-control"
                >
        </pmd-textfield>
    </div>
    <div class="d-flex mt-3">
        <p class="mb-0"><a routerLink="/login"
                class="link-text">Resend code</a></p>
        <span class="ms-auto">0:30</span>
    </div>
    <div class="mt-4">
        <button type="submit"
            pmdRipple
            routerLink="/reset-password"
            pmd-btn-raised
            color="secondary">Verify Code</button>
        <p class="mt-3 mb-0"
            class="link-text mt-3">
            <span [pmdPopover]="popTemplate"
                container="body"
                placement="bottom"
                containerClass="turnOverPopUp pmd-card mb-1"
                class="py-2">Did not receive the verification code?</span>
        </p>
        <ng-template #popTemplate>
            <div class="verification-code">
                <div class="title-info">If you have not received a verification code on your email id or your mobile
                    number:</div>
                <ul class="list-group pmd-list mb-3">
                    <li class="list-group-item w-100 d-flex"><span aria-hidden="true"
                            class="material-symbols-outlined me-2 pmd-icon-primary pmd-icon-sm">email</span> <span>Check
                            your email inbox spam folder.</span></li>
                    <li class="list-group-item w-100 d-flex"><span aria-hidden="true"
                            class="material-symbols-outlined me-2 pmd-icon-primary pmd-icon-sm">refresh</span> <span>Try
                            "Resend code" option above.</span></li>
                    <li class="list-group-item w-100 d-flex"><span aria-hidden="true"
                            class="material-symbols-outlined me-2 pmd-icon-primary pmd-icon-sm">check</span>
                        <span>Please check if you have entered a correct email id and mobile number.</span>
                    </li>
                </ul>
                <p>For any further assistance please contact our support team at <a href="mailto:support@kharchaapp.com"
                        target="_blank">[support@kharchaapp.com]</a>.</p>
            </div>
        </ng-template>
    </div>
</div> -->
<!-- End via OTP -->